module.exports = __webpack_public_path__ + "img/chanpin.4b2ca455.png";